import SuccessIcon from "shared/icons/status-icons/success-icon.svg?react";
import FailedIcon from "shared/icons/status-icons/fail-icon.svg?react";
import { cx } from "shared/utils";

type CriteriaBadgeIconProps = {
  hasCriteria: boolean;
  success: boolean;
  className?: string;
};

export const CriteriaBadgeIcon = ({
  success,
  hasCriteria,
  className
}: CriteriaBadgeIconProps) => {
  if (!hasCriteria) return null;

  const classNames = cx("no-print shrink-0 stroke-none w-5", className);

  if (success)
    return <SuccessIcon className={cx("text-success-600", classNames)} />;

  return <FailedIcon className={cx("text-danger-500", classNames)} />;
};
